// extracted by mini-css-extract-plugin
export default {"jobListTable":"JobListTable_jobListTable__NxBzA"};